import { all } from 'redux-saga/effects';

import quickshopWebSaga from 'apps/modules/quickshopweb/QuickshopWebSaga';

export default function*() {
  yield all([ quickshopWebSaga()]);
}
